<template>
  <div class="instant-page">
    <div class="loading-instant" v-if="isShowLoading">
      <div class="container gp-main-body px-1 px-xs-2 px-sm-4 px-md-5 px-xl-6 px-lg-2 px-mlg-2 mt-2">
        <div class="loading-instant-header">
          <div class="loading-instant-header-title">
            <div class="landing-title skeleton skeleton-light"></div>
            <div class="landing-desc skeleton skeleton-light"></div>
          </div>
          <div class="landing-create skeleton skeleton-light"></div>
        </div>
        <div class="loading-instant-filter">
          <div class="landing-search skeleton skeleton-light"></div>
          <div class="landing-filter skeleton skeleton-light"></div>
        </div>
        <GpListLoading :quantity="5" />
      </div>
    </div>
    <iframe ref="iframe" class="instant" :allow="`clipboard-read ${url}; clipboard-write ${url};`" width="100%" height="100%" :src="iframeUrl"></iframe>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { GpListLoading } from "@/core/shared/GpList";
import trackEvent, { VIEW_INSTANT_LANDING_PAGE } from "@/utils/tracker";

export default {
  components: {
    GpListLoading
  },
  data() {
    return {
      url: process.env.VUE_APP_INSTANT_BASE_URL || "https://builder.gempages.xyz",
      loadingCount: 0,
      isShowLoading: true,
      iframeUrl: ""
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo",
      instantShopId: "instantShopId",
      instantShopToken: "instantShopToken"
    }),
    isGemPagesV6() {
      return this.shopInfo.shopType.isGemPagesV6;
    },
    isGemPagesV7() {
      return this.shopInfo.shopType.isGemPagesV7;
    }
  },
  watch: {
    $route: function(to) {
      if (to.name !== "InstantPages") {
        this.resetDocumentTitle();
        return;
      }

      this.updateDocumentTitle(to.path);

      if (this.isShowLoading) {
        this.getIframeUrl();
        return;
      }
      this.emitEventChangePageToInstant();
    },
    instantShopId(newVal) {
      if (newVal && !this.isGemPagesV6) {
        this.getIframeUrl();
      }
    },
    instantShopToken(newVal) {
      if (newVal && !this.isGemPagesV6) {
        this.getIframeUrl();
      }
    }
  },
  created() {
    const APPLY_TIME = 1688688000000; // 2023-07-07
    if (new Date(this.shopInfo.createdAt).getTime() >= APPLY_TIME) {
      const currentRouterType = this.$route.params.type;
      const paramTypeGemPagesV6 = {
        "landing-pages": "LandingPages",
        "home-pages": "HomePages",
        "product-pages": "ProductPages",
        "collection-pages": "CollectionPages",
        "article-pages": "ArticlePages"
      };
      const redirectRouterName = paramTypeGemPagesV6[currentRouterType];
      if (redirectRouterName && (this.shopInfo.shopType.isGemPagesV6 || (this.shopInfo.shopType.isGemPagesMixed && redirectRouterName != "LandingPages"))) {
        this.$router.replace({ name: redirectRouterName });
      }
    }

    this.updateDocumentTitle(this.$route.path);

    this.listenMessageFromIframe();
    trackEvent({ eventId: VIEW_INSTANT_LANDING_PAGE });
    this.getIframeIfIsNotV7();
  },
  methods: {
    getIframeIfIsNotV7() {
      if (this.isGemPagesV6) {
        this.getIframeUrl();
        return;
      }
      if (this.instantShopId) {
        this.getIframeUrl();
      }
    },
    getIframeUrl() {
      const params = this.$route.params;
      if (!this.isGemPagesV6 && params.type && params.type !== "static") {
        const path = this.$route.path;
        this.iframeUrl = `${this.url}${path}?shop=${this.shopInfo.shopifyDomain}&shop_id=${this.instantShopId}`;
        return;
      } else if (params.type == "static") {
        this.iframeUrl = `${this.url}/instant/pages?shop=${this.shopInfo.shopifyDomain}&shop_id=${this.instantShopId}&token=${this.instantShopToken}`;
      }
    },
    emitEventChangePageToInstant() {
      const iframeWindow = this.$refs.iframe?.contentWindow;
      iframeWindow?.postMessage(`openPageList:${this.getPageType()}`, this.url);
    },
    getPageType() {
      switch (this.$route.params.type) {
        case "landing-pages": {
          return "GP_STATIC";
        }
        case "home-pages": {
          return "GP_INDEX";
        }
        case "product-pages": {
          return "GP_PRODUCT";
        }
        case "collection-pages": {
          return "GP_COLLECTION";
        }
        case "article-pages": {
          return "GP_ARTICLE";
        }
        default: {
          return "STATIC";
        }
      }
    },
    listenMessageFromIframe() {
      window.addEventListener("message", e => {
        if (typeof e.data !== "string") {
          return;
        }
        this.checkOpenEditorInstant(e.data);
        this.checkOpenIntercomFromIframe(e.data);
        this.checkCloseLoading(e.data);
        this.navigateFromInstant(e.data);
      });
    },

    navigateFromInstant(data) {
      const splitParam = data?.split("@");
      const type = splitParam?.[0];
      const pathName = splitParam?.[1];
      if (type === "navigateFromInstant" && pathName) {
        this.$router.replace({
          name: pathName
        });
      }
    },

    checkOpenEditorInstant(data) {
      // event format [eventName@message]
      const splitParam = data?.split("@");
      const type = splitParam?.[0];
      const instantUrl = splitParam?.[1];
      if (type === "openInstant" && instantUrl) {
        window.location.href = instantUrl;
      }
    },
    checkOpenIntercomFromIframe(data) {
      if (data === "showIntercom") {
        this.$chatbox.show();
      }
    },
    checkCloseLoading(data) {
      if (data === "hideLoading") {
        this.hideLoading();
      }
    },
    hideLoading() {
      this.isShowLoading = false;
    },
    updateDocumentTitle(path) {
      const pageTypeMap = {
        "/instant/landing-pages": "Landing Pages",
        "/instant/home-pages": "Home Pages",
        "/instant/product-pages": "Product Pages",
        "/instant/collection-pages": "Collection Pages",
        "/instant/article-pages": "Article Pages"
      };

      const pageType = pageTypeMap[path] || "Dashboard";
      const gemPagesVersion = this.isGemPagesV7 ? "GemPages 7" : "GemPages";

      document.title = `${pageType} - ${gemPagesVersion}`;
    },
    resetDocumentTitle() {
      document.title = "Dashboard - GemPages";
    }
  }
};
</script>

<style lang="scss" scoped>
.instant {
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin: 0;
}
.instant-page {
  position: relative;
  width: 100%;
  height: 100%;
}
.loading-instant {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  &-header {
    display: flex;
    margin-bottom: 46px;
    justify-content: space-between;
    .landing-title {
      width: 421px;
      height: 30px;
      margin-bottom: 8px;
    }
    .landing-desc {
      width: 569px;
      height: 16px;
    }
    .landing-create {
      width: 221px;
      height: 40px;
    }
  }
  &-filter {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 24px;
    .landing-search {
      width: 258px;
      height: 40px;
      margin-right: 20px;
    }
    .landing-filter {
      width: 312px;
      height: 40px;
    }
  }
}
::v-deep .gp-list-loading {
  width: 100%;
}
</style>
